import AbstractApiModel from '@/models/abstracts/AbstractApiModel';
import doc from '@model-core/decorators/doc';

/** Statut d'un utilisateur (enum App\Entity\UserStatus de l'API, GET /user_statuses) : id, reference (clé utilisée par le front), label */
export default class UserStatusModel extends AbstractApiModel {
  protected _path = '/user_statuses/{?id}';

  @doc.string declare reference: string;
  @doc.string declare label: string;

  /** URN à envoyer à l'API pour écrire la relation (corps d'un POST / PATCH) ; un filtre prend l'id */
  get urn(): string {
    return this.get<string, string>('@urn', `$:teiji:user_status:${this.id}`);
  }
}
